import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCommonModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskModule } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { AddressFormComponent } from "./address-form.component";

@NgModule({
    declarations: [AddressFormComponent],
    exports: [AddressFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatIconModule,
        MatButtonModule,
        MatCommonModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        NgxSpinnerModule,
        NgxMaskModule.forRoot(),
        TranslateModule
    ]
})
export class AddressFormModule {}
